<div class="courses-all">
  <div class="courses-all__container">

    <div class="courses-all__column">
      <app-course-list-header
        [title]="'app.components.coursesAll.title'"
        [subtitle]="'app.components.coursesAll.subtitle'"
        [coursesCount]="filteredCoursesCount()"
        [filterChips]="filterChips"
        (chipSelected)="onChipSelected($event)"
      ></app-course-list-header>

      @if (showDraftsSection()) {
      <div class="courses-all__drafts-section">
        <h3 class="courses-all__drafts-title">{{ 'app.components.coursesAll.draftsTitle' | translate }}</h3>
        @if (hasNotPublishedCourses()) {
          <div class="courses-grid">
            <app-course-card
              *ngFor="let draft of draftCourses()"
              [course]="draft"
              [isDraft]="true"
              (click)="onOpenCourseCreator(draft.id)"
            ></app-course-card>
          </div>
        } @else {
          <div class="courses-all__drafts-empty">{{ 'app.components.coursesAll.draftsEmpty' | translate }}</div>
          @if (publishedCourses().length === 0) {
            <app-empty-course-list [showButton]="true" (buttonClick)="onOpenModal()"></app-empty-course-list>
          }
        }
      </div>
      }

      @if (showPublishedSection()) {
      <div class="courses-all__published-section">
        <h3 class="courses-all__published-title">{{ 'app.components.coursesAll.publishedTitle' | translate }}</h3>
        @if (publishedCourses().length > 0) {
          <div class="courses-all__published-grid">
            <button
              type="button"
              class="courses-all__published-grid-action"
              *ngFor="let course of publishedCourses()"
              (click)="onOpenPublishedCourse(course.id)"
            >
              <app-course-card [course]="course" [isDraft]="false"></app-course-card>
            </button>
          </div>
        } @else {
          <div class="courses-all__drafts-empty">{{ 'app.components.coursesAll.publishedEmpty' | translate }}</div>
        }
      </div>
      }

      <app-modal [config]="{ title: 'app.components.courseModal.createTitle', minHeight: '50rem', minWidth: '60rem', maxWidth: '60rem' }" [isOpen]="isModalOpen()" (closed)="isModalOpen.set(false)">
        <app-course-creator [selectedCourse]="selectedCourse()" [initialStep]="courseCreatorStep()"></app-course-creator>
      </app-modal>

    </div>

    <!-- Right Column: Progress & Performance -->
    <div class="courses-all__column">
      <div class="section">
        <div class="section__header">
          <h2 class="section__title">{{'app.components.coursesAll.progress' | translate}}</h2>
          <app-cta-button *ngIf="hasNotPublishedCourses()" variant="light" size="small" (click)="onOpenModal()">
            <img cta-prefix src="/public/svgs/plus-rounded.svg" alt="Plus" />
            <span cta-label>{{ 'app.components.studiesAll.new' | translate }}</span>
          </app-cta-button>
        </div>
        <app-top-performance></app-top-performance>
      </div>
    </div>
  </div>
</div>
